module.exports = __webpack_public_path__ + "1ab61c5c89ce06b27ea6b2c36ea8e42c.png";